import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { StatusLevel } from '@/hooks/useDashboardInsights';

interface NeedsAttentionHeaderProps {
  status: StatusLevel;
  headline: string;
  subheadline: string;
}

export const NeedsAttentionHeader: React.FC<NeedsAttentionHeaderProps> = ({
  status,
  headline,
  subheadline,
}) => {
  const statusConfig = {
    good: {
      label: 'On Track',
      badgeClass: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    },
    attention: {
      label: 'Needs Attention',
      badgeClass: 'bg-amber-50 text-amber-700 border-amber-200',
    },
    action: {
      label: 'Action Required',
      badgeClass: 'bg-red-50 text-red-700 border-red-200',
    },
  };

  const config = statusConfig[status];

  return (
    <div className="space-y-2">
      <Badge 
        variant="outline" 
        className={cn('font-medium text-xs', config.badgeClass)}
      >
        {config.label}
      </Badge>
      <h1 className="text-3xl font-serif font-semibold tracking-tight text-foreground">
        {headline}
      </h1>
      <p className="text-muted-foreground">
        {subheadline}
      </p>
    </div>
  );
};
